import { WagmiProvider } from "wagmi";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { StashSyncProvider } from "./stash/StashSyncProvider";
import { stash } from "./stash/stash";
import { Address } from "viem";
import { EntryKitProvider, defineConfig } from "@latticexyz/entrykit/internal";
import { wagmiConfig } from "./wagmiConfig";
import { chainId } from "./common";

const queryClient = new QueryClient();

export type Props = {
  worldDeploy: {
    address: Address;
    blockNumber: bigint | null;
  };
  children: ReactNode;
};

export function Providers({ worldDeploy, children }: Props) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <EntryKitProvider
          config={defineConfig({
            chainId,
            worldAddress: worldDeploy.address,
            theme: "dark",
          })}
        >
          <StashSyncProvider
            address={worldDeploy.address}
            startBlock={worldDeploy.blockNumber ?? undefined}
            stash={stash}
          >
            {children}
          </StashSyncProvider>
        </EntryKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
